import * as z from "zod";

export const getMetaLeadAdsPages = {
  name: "getMetaLeadAdsPages" as const,
  input: z.null(),
  output: z.object({
    pages: z.array(z.object({ id: z.string(), name: z.string() })),
  }),
};
